import { Text } from '@interco/inter-ui/components/Text'

import * as S from './style'

type Content = {
  title: string
  description: string
}

const ContentText: Content[] = [
  {
    title: 'Saldo',
    description: `Informações da conta, saldo disponível, saldo bloqueado, outros saldos.`,
  },
  {
    title: 'Limites',
    description: `Informações da conta, limite utilizado, limite contratado de cheque especial.`,
  },
  {
    title: 'Extrato',
    description: `Informações da conta, detalhes da transação.`,
  },
]

export const Account = () => (
  <S.Container>
    <Text variant="body-2" style={{ fontSize: 16 }}>
      Estes serão os dados compartilhados:
    </Text>
    {ContentText.map((content) => (
      <S.Content key={content.title}>
        <Text variant="body-1" bold colorWeight={500}>
          {content.title}
        </Text>
        <Text variant="body-2">{content.description}</Text>
      </S.Content>
    ))}
  </S.Container>
)
